import z from "zod"

export const CompanyIntegrationProviderEnum = z.enum([
  "Shopify",
  "BigBlue",
  "Reveni",
  "Amphora",
  "LoopReturns",
  "Rever",
])

export const CompanyActionEnum = z.enum(["FindOrder", "CancelOrder", "CheckReturn"])

export const UpdateCompanyIntegrationConfigurationSchema = z.object({
  provider: CompanyIntegrationProviderEnum,
  action: CompanyActionEnum,
  isActive: z.boolean(),
})
